import { getSimbixProvider } from './connect';
import { typesInModuleGetParams, typeGetParams, nodesGetParams, nodesGetByIdsParams,
	typePlantUMLParams, typeXSDParams } from './request'

import {responseEMDHistory, responseEMDContent, responseTags, responseLangs} from './demo-response';


export const simbix = getSimbixProvider()
export const csiHost = "http://csi.semanticpro.org"; //"http://csi.hbz.local";
export const ipssrvHost = "http://ipssrv.hbz.local";
//Идентификатор модуля ADMS в Simbix
export const admsModule = "adms"
//Идентификатор модуля docs в Simbix
export const docsModule = "docs"

//
//Авторизация в simbix с использование логина и пароля
//
export const executeAuthenticate = () =>{
	return simbix.connect()
		.then(response => { console.log("executeAuthenticate"); console.log(response);
			if (response.success) 
				return {response, simbix}
			console.error(new Error("authenticate ", response));
			return Promise.reject(response);
		})
}


//Базовая функция последовательных вызовом запросов, выполнящих обращение к данным
const seqRunner = ([first, ...tail], props) => {
	if (first === undefined) return Promise.resolve();
	try {
	  return tail.reduce((p, deed) => p.then(deed), first(props));
	} catch (e) {
	  return Promise.reject(e);
	}
}

//
//Получение метаописания модель. Используется:
// 1. runGetTypeDescription - описание одного типа
// 2. runGetTypesDescription - описание списка типов
// 3. runGetTypesInModule - список типов в модуле
//
const runGetTypeDescription = (host, module, type) => {
	return simbix.getNodes(host, Object.assign({}, typeGetParams, {type, module}))
        .then(response => { 
			//console.log('typeGetParams'); console.log(response);
			if (response.success) 
				return {type: response.data.result}
			console.error(new Error("typeGetParams "+response));
			return Promise.reject(response);
		})
}
const runGetTypesDescription = (response) => {
	const {props, types} = response
	const {host, module} = props
	return Promise.all(types.map(type => runGetTypeDescription(host, module, type)))
		.then((response) =>{
			//console.log("Promise.all", response)
			const description = {}
			Object.keys(response).forEach((item) => {description[response[item].type.type] = response[item].type.data})
			return {props, description, types}
		})
}
const runGetTypesInModule = (props) => {
	const {host, module} = props
	typesInModuleGetParams.module = module 
	return simbix.getNodes(host, typesInModuleGetParams)
        .then(response => { 
			//console.log('runGetTypesInModule'); console.log(typesInModuleGetParams); console.log(response);
			//Загрушка для скорости получения описания adms модуля
			const types = (module=='adms')? ['adms_asset', 'adms_assetdistribution', 'adms_assetrepository'] : response.data.result.data;
			return {props, types}
		})
}
export const executeGetModuleDescription = (host, module) => {
	return seqRunner([runGetTypesInModule, runGetTypesDescription], {host, module})
        .then(response => { 
			//console.log('executeGetModuleDescription', host); console.log(response);
			return {description: response}
		})
}

//
//Получение описания модуля adms. Используется:
// 1. runGetADMSModuleDescription - описание модуля adms
// 2. runGetAssetRepository - список доступных каталогов (все узлы типа adms_assetrepository)
// 3. runGetAllScheme - все схемы в модуле (все узлы типы skos_conceptscheme)
//
const runGetADMSModuleDescription = (props) => {
	const {host, module} = props;
	return executeGetModuleDescription (host, module);
}
const runGetAssetRepository = (response) => {
	//console.log("runGetAssetRepository", response)
	const {props, types, description} = response.description
	const {host, module} = props
	nodesGetParams.module = module;
	nodesGetParams.type = "adms_assetrepository"
	nodesGetParams.condition = "";
	return simbix.getNodes(host, nodesGetParams)
        .then(response => { 
			//console.log('runGetAssetRepository'); console.log(nodesGetParams); console.log(response);
			if (response.success) 
				return {types, description, props, assetrepository: response.data.result.data}
			console.error(new Error("runGetAssetRepository "+response));
			return Promise.reject(response);
		})
}
const runGetAllScheme = (response) => {
	const {props, types, description, assetrepository} = response
	const {host, module} = props
	nodesGetParams.module = module;
	nodesGetParams.type = "skos_conceptscheme"
	nodesGetParams.condition = "";
	return simbix.getNodes(host, nodesGetParams)
        .then(response => { 
			//console.log('runGetAllScheme'); console.log(nodesGetParams); console.log(response);
			if (response.success) 
				return {types, description, props, assetrepository, schemas: response.data.result.data}
			console.error(new Error("runGetAllScheme "+response));
			return Promise.reject(response);
		})
}
export const executeGetADMSModuleDescription = (host) => {
	return seqRunner([runGetADMSModuleDescription, runGetAssetRepository, runGetAllScheme], {host, module: admsModule})
        .then(response => { 
			//console.log('executeGetADMSModuleDescription', host); console.log(response);
			return {...response}
		})
}

//
//Получение описания модуля docs
//
const runGetDocsModuleDescription = (props) => {
	const {host, module} = props;
	return executeGetModuleDescription (host, module);
}
export const executeGetDocsModuleDescription = (host) => {
	return seqRunner([runGetDocsModuleDescription], {host, module: docsModule})
        .then(response => { 
			//console.log('executeGetDocsModuleDescription', host); console.log(response);
			return {...response.description, props: {host, module: docsModule}}
		})
}

//
//Получение списка ключевых слов
//
export const executeGetTags = () => {
	return Promise.resolve({data: responseTags});
}

//
//Получение списка доступных языков
//
export const executeGetLangs = () => {
	return Promise.resolve({data: responseLangs});
}

//
//Получение списка СА. Используется:
// 1. runGetAssets - список доступных элементов (все узлы типа adms_asset)
// 2. runGetTags - список доступных ключевых слов/тегов (все узлы типа dcat_keyword)
//
const runGetAssets = (props) => {
	const {host, module, type, condition} = props;
	nodesGetParams.module =module;
	nodesGetParams.type = type;
	nodesGetParams.condition = condition;
	return simbix.getNodes(host, nodesGetParams)
        .then(response => { 
			//console.log('executeGetAssets'); console.log(nodesGetParams); console.log(response);
			if (response.success) 
				return {assets: response.data.result, props}
			console.error(new Error("runGetAssets "+response));
			return Promise.reject(response);
		})
}

const runGetTags = (response) => {
	const {props, assets} = response;
	const {host, module, condition} = props;
	nodesGetParams.module =module;
	nodesGetParams.type = "dcat_keyword";
	nodesGetParams.condition = "ParId.ParId."+condition;
	return simbix.getNodes(host, nodesGetParams)
        .then(response => { 
			//console.log('executeGetAssets'); console.log(nodesGetParams); console.log(response);
			if (response.success) 
				return {tags: response.data.result, props, assets}
			console.error(new Error("runGetTags "+response));
			return Promise.reject(response);
		})

}

//
// Загрузка списка активов. В свойствах указывается:
// 1. модуль (module) - откуда взять данные,
// 2. тип узла (type) - который содержит актив
// 3. дополнительное условие отбора активов (condition) - дополнительное условия для фильтрации активов
// 4. хост сервера (host) - для вызова REST хапроса
//
export const executeGetAssets = (props) => {
	//console.log("executeGetAssets", props)
	const module = (props.module)?props.module:admsModule;
	const type = (props.type)?props.type:"adms_asset";
	const condition = (props.condition)?props.condition:"";
	const host = (props.host)?props.host:csiHost;
	return seqRunner([runGetAssets, runGetTags], {host, module, type, condition})
        .then(response => { 
			//console.log('executeGetAssets'); console.log(response);
			return {...response}
		})
}

//
//Получение значений свойств элемента Каталога моделей
//
export const executeGetAsset = (props) => {
	//console.log("executeGetAsset", props)
	const {host, module, type, id} = props;
	nodesGetByIdsParams.module = (module)?module:"adms";
	nodesGetByIdsParams.type = (type)?type :"adms_asset"
	nodesGetByIdsParams.ids = [id];
	return simbix.getNodes(host, nodesGetByIdsParams)
        .then(response => { 
			//console.log('executeGetAsset'); console.log(nodesGetByIdsParams); console.log(response);
			if (response.success){
				if (response.data.result && response.data.result.data && 
					Array.isArray(response.data.result.data) && (response.data.result.data.length>0))
				return {asset: response.data.result.data[0]}
			}
			console.error(new Error("executeGetAsset "+response));
			return Promise.reject(response);
		})
}

//
//Получение списка групп документов/файлов
//
export const executeGetDocsGroup = (props) => {
	//console.log("executeGetDocsGroup", props)
	const {module, type, condition} = props;
	nodesGetParams.module = (module)?module:"docs";
	nodesGetParams.type = (type)?type :"folder"
	nodesGetParams.condition = (condition)?condition:"";
	return simbix.getNodes(ipssrvHost, nodesGetParams)
        .then(response => { 
			//console.log('executeGetDocsGroup'); console.log(nodesGetParams); console.log(response);
			if (response.success) 
				return {groups: response.data.result}
			console.error(new Error("executeGetDocsGroup "+response));
			return Promise.reject(response);
		})
	//return Promise.resolve({data: responseDocsGroup});
}

//
//Получение списка документов для группы
//
export const executeGetDocs = (props) => {
	const {module, type, condition} = props;
	nodesGetParams.module = (module)?module:"docs";
	nodesGetParams.type = (type)?type :"document"
	nodesGetParams.condition = (condition)?condition:"";
	return simbix.getNodes(ipssrvHost, nodesGetParams)
        .then(response => { 
			//console.log('executeGetDocs'); console.log(nodesGetParams); console.log(response);
			if (response.success) 
				return {docs: response.data.result}
			console.error(new Error("executeGetDocs "+response));
			return Promise.reject(response);
		})
}

//
//Получение 
//
export const executeGetDoc = (props) => {
	const {module, type, id} = props;
	nodesGetParams.module = (module)?module:"docs";
	nodesGetParams.type = (type)?type :"document"
	nodesGetParams.condition = (id)?"NodId="+id:"";
	return simbix.getNodes(ipssrvHost, nodesGetParams)
        .then(response => { 
			//console.log('executeGetDoc'); console.log(nodesGetParams); console.log(response);
			if (response.success){
				if (response.data.result && response.data.result.data && 
					Array.isArray(response.data.result.data) && (response.data.result.data.length>0))
				return {properties: response.data.result.data[0]}
			}
			console.error(new Error("executeGetDocs "+response));
			return Promise.reject(response);
		})
}

//
//Получение истории ЕМД
//
export const executeGetEMDHistory = (props) => {
	//console.log("executeGetHistoryEMD", props)
	const module = (props.module)?props.module:admsModule;
	const type = (props.type)?props.type:"adms_asset";
	const condition = (props.condition)?props.condition:"";
	const host = (props.host)?props.host:csiHost;
	// return seqRunner([runGetAssets, runGetTags], {host, module, type, condition})
    //     .then(response => { 
	// 		//console.log('executeGetHistoryEMD'); console.log(response);
	// 		return {...response}
	// 	})
	return Promise.resolve(responseEMDHistory);
}

//
//Получение содержимого ЕМД в виде json в нотации VOWL
//
export const executeGetEMDContent = (props) => {
	const module = (props.module)?props.module:admsModule;
	const type = (props.type)?props.type:"adms_asset";
	const condition = (props.condition)?props.condition:"";
	const host = (props.host)?props.host:csiHost;
	return  Promise.resolve({content: responseEMDContent});
}

/**
 * Получение URL на картинку UML
 */
export const executeGetPlantUML = (props) =>{
	const {script} = props;
	const host = (props.host)?props.host:csiHost;
	typePlantUMLParams.script = script;
	return simbix.getNodes(host, typePlantUMLParams)
        .then(response => { 
//			console.log('executeGetPlantUML'); console.log(response);
			if (response.success) 
				return {data: response.data.result.data}
			console.error(new Error("executeGetPlantUML "+response));
			return Promise.reject(response);
		})

}

/**
 * Получение URL на скачивание XSD файла
 */
export const executeGetXSD = (props) =>{
	const {name, iri} = props;
	const host = (props.host)?props.host:csiHost;
	typeXSDParams.name = name;
	typeXSDParams.URI = iri;
	return simbix.getNodes(host, typeXSDParams)
        .then(response => { 
			console.log('executeGetXSD'); console.log(response);
			if (response.success) 
				return {data: response.data.result.data}
			console.error(new Error("executeGetXSD "+response));
			return Promise.reject(response);
		})

}
